import type { GetUsersResponse } from '@vy/api-definition';
import { GetUsersResponseSchema } from '@vy/api-definition';
import { useQuery } from 'react-query';
import { getPrivateApi } from '../../services/api';
import { queryKeys } from '../../services/query-key/query-keys';
import type { CustomUseQueryOptions } from './requests-types/custom-use-query-options';

export function useUsers(options?: CustomUseQueryOptions<GetUsersResponse>) {
  return useQuery({
    queryKey: queryKeys.users(),
    queryFn: async () => {
      const api = getPrivateApi();

      const usersResponse = await api.getUsers();

      return GetUsersResponseSchema.parse(usersResponse satisfies GetUsersResponse);
    },
    ...options,
  });
}
